<template>
  <div></div>
</template>

<script>
export default {
  name: 'PlayerPendingInfoForceApplyMigration',

  props: {
    pending: {
      type: Object,
      required: true,
    }
  },

  data() {
    return {
    };
  },
}
</script>
